var _ = require('underscore');
var Azure = EY.Consultation.Lookups.Azure;
var Lookups = EY.Consultation.Lookups;

function createCDARequest(body) {

    var headerOptions = new Headers();
    headerOptions.append("apiKey", Azure.EdwSubscriptionId);
    headerOptions.append("Authorization", Azure.CDAToken);
    headerOptions.append("content-type", "application/json;charset=utf-8");

    var fetchOptions = {
        method: 'POST',
        headers: headerOptions,
        body: body,
        redirect: 'follow'
    };

    return fetchOptions;
}

// Convert the CDA Response to match the entities used for handling CDA Data
var transformEngagementCDAResponse =  function(response) {
    var data = (response.data.getEngagement && response.data.getEngagement.data) || [];

    var result = _.map([data], function(item) {
        return {
            ClientId: item.clientId,
            ClientName: item.clientName,
            Country: (item.engagementLocation && item.engagementLocation[0].countryName) || '',
            CountryCode: (item.engagementLocation && item.engagementLocation[0].countryCode) || '',
            EngagementId: item.id,
            EngagementName: item.name,
            IndustrySector: item.engagementIndustry && item.engagementIndustry[0].industrySectorName
        }
    });
    return result;
};

var transformClientCDAResponse =  function(response) {
    var data =  (response.data.searchClients && response.data.searchClients.data) || [];

    var result = [];
    _.compact(_.map(data, function(item) {
        if (!!item.engagements.data && item.engagements.data.length) {
            _.map(item.engagements.data, function(innerItem) {
                if (innerItem.id && innerItem.name) {
                    result.push({
                        ClientId: item.id,
                        ClientName: item.name,
                        Country: item.clientAddress && item.clientAddress[0].countryName,
                        CountryCode: item.clientAddress && item.clientAddress[0].countryCode,
                        EngagementId: innerItem.id || '',
                        EngagementName: innerItem.name || '',
                        IndustrySector: (item.clientIndustry && item.clientIndustry[0].industrySectorName)
                    })
                }
            })
        }
    }));
    return result;
};

module.exports.getEngagement = function(engagementId) {

    var body = JSON.stringify({
        query: Azure.EdwEngagementQuery,
        variables: { "id": engagementId }
    });

    return fetch(Azure.EdwCDAUrl, createCDARequest(body))
        .then(function(response) {

            return response.json();
        }).then(function(result) { 
            
            return transformEngagementCDAResponse(result);
         });
};

module.exports.searchClients = function(searchTerm) {

    var body = JSON.stringify({
        query: Azure.EdwEngagementQueryClientName,
        variables: {
            "searchTerm": searchTerm,
            "limit": Lookups.Configuration.EdwMaxSearchResults, 
            "offset":"0"
        }
    });

    return fetch(Azure.EdwCDAUrl, createCDARequest(body))
        .then(function(response) {

            return response.json();
        }).then(function(result) { 

            return transformClientCDAResponse(result);
         });
};


// WEBPACK FOOTER //
// ./js/Modules/Service/EdwCDALookup.js